/* © 2024-2026 Johannes Roob. Proprietärer Code. Keine Nutzung oder Weitergabe ohne Erlaubnis. | Proprietary code. No use or distribution without permission. */

import { mustClosest, must } from "../../util/must";

export function tableMoveRowUp(target: HTMLElement) {
    const tr = mustClosest<HTMLTableRowElement>(target, "tr");
    const tbody = must(tr.parentNode, HTMLTableElement);
    const rows = Array.from(tbody.rows);
    const index = rows.indexOf(tr);

    if (index == 0) {
        tbody.appendChild(tr);
    } else {
        tbody.insertBefore(tr, rows[index - 1]);
    }
}

export function tableMoveRowDown(target: HTMLElement) {
    const tr = mustClosest<HTMLTableRowElement>(target, "tr");
    const tbody = must(tr.parentNode, HTMLTableElement);
    const rows = Array.from(tbody.rows);
    const index = rows.indexOf(tr);

    if (index == rows.length - 1) {
        tbody.insertBefore(tr, rows[0]);
    } else {
        tbody.insertBefore(rows[index + 1], tr);
    }
}